import { SubmissionError } from 'redux-form';
import { REQUIRED_FIELDS } from './constants';
import { goToElement } from '../../utils/goToElement';

export const transformToValidationErrors = errors => {
	goToElement(Object.keys(errors)[0]);
	return Object.entries(errors).reduce((prev, [key, error]) => {
		if (!prev[key]) {
			prev[key] = {};
		}

		prev[key] = error;

		return prev;
	}, {});
};

export const validate = values => {
	REQUIRED_FIELDS.forEach(key => {
		if (!values?.[key]) {
			goToElement(key);
			throw new SubmissionError({ [key]: 'Заполните это поле' });
		}
	});
};
